import React from 'react';
import { Box } from '@withjoy/joykit';
import { getPillWrapperStyles, StyledPill, StyledPillLabel, StyledPillWrapper, styles } from './ProductVariantStringList.styles';
import type { ProductVariantStringListProps } from './types';
import { useProductVariantStringList } from './useProductVariantStringList';

export const ProductVariantStringList: React.FC<ProductVariantStringListProps> = (props: ProductVariantStringListProps) => {
  const { optionsToRender, handleOptionChange, handleMouseOver, selectedOptionId } = useProductVariantStringList(props);
  const { isQuickAddForm } = props;
  const { name = '', variant = 'pill', checkAvailability = false, size } = props;
  return (
    <StyledPillWrapper __css={getPillWrapperStyles({ size, variant })}>
      {optionsToRender.map(option => {
        const isSelected = selectedOptionId === option.id;
        return (
          <StyledPill
            as="label"
            key={option.id}
            isQuickAddForm={isQuickAddForm}
            onMouseOver={(e: React.MouseEvent) => handleMouseOver(e, option.id)}
          >
            <Box
              as="input"
              display="none"
              type="radio"
              name={name}
              checked={isSelected}
              __css={styles.pillInput}
              onChange={(e: React.ChangeEvent) => handleOptionChange(e, option.id)}
            />
            <StyledPillLabel
              as={isQuickAddForm ? 'span' : 'div'}
              wordBreak="break-word"
              paddingX={4}
              isQuickAddForm={isQuickAddForm}
              data-checked={isSelected || null}
              data-readonly={(checkAvailability && option.notAvailable) || null}
            >
              {option.label}
            </StyledPillLabel>
          </StyledPill>
        );
      })}
    </StyledPillWrapper>
  );
};
